<template>
  <!-- Adapts between f7-popup (large screens) and f7-sheet (small screens) -->
  <AdaptiveSheet :opened="opened" class="share-to-chat-sheet">
    <f7-toolbar>
      <div class="left padding-left">
        <strong style="font-size: 13px;">{{ $t('tamtammessage.shareInChat') }}</strong>
      </div>
      <div class="right padding-right">
        <f7-link sheet-close popup-close>
          <f7-icon f7="multiply" size="18" />
        </f7-link>
      </div>
    </f7-toolbar>

    <f7-page-content>
      <div class="sctc-search">
        <input
          v-model="searchQuery"
          type="text"
          :placeholder="$t('tamtammessage.searchAChat')"
          class="sctc-search-input"
        />
      </div>

      <f7-list v-if="filteredGroups.length > 0" class="sctc-list" media-list>
        <f7-list-item
          v-for="group in filteredGroups"
          :key="group.id"
          :title="group.name"
          :after="group.groupType === 'PERSONAL' ? $t('common.private') : group.groupType"
          link="#"
          checkbox
          @click="selectGroup(group)"
        >
          <template #media>
            <img
              v-if="group.avatar"
              :src="group.avatar"
              class="sctc-avatar"
            />
            <f7-badge v-else color="auto" class="sctc-avatar-badge">
              {{ getInitial(group.name) }}
            </f7-badge>
          </template>
        </f7-list-item>
      </f7-list>

      <div v-else class="sctc-empty">
        <p>{{ $t('tamtammessage.noChatFound') }}</p>
      </div>
    </f7-page-content>
  </AdaptiveSheet>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import AdaptiveSheet from '../common/AdaptiveSheet.vue';

const props = defineProps({
  opened: { type: Boolean, default: false },
  groups: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:opened', 'selectGroup']);

const searchQuery = ref('');

// Clear the search box whenever the modal is closed
watch(
  () => props.opened,
  (value) => {
    if (!value) searchQuery.value = '';
  }
);

function closeModal() {
  emit('update:opened', false);
}

const filteredGroups = computed(() => {
  if (!searchQuery.value.trim()) return props.groups;
  const q = searchQuery.value.toLowerCase();
  return props.groups.filter((g) => g.name && g.name.toLowerCase().includes(q));
});

function getInitial(name) {
  if (!name) return '?';
  return (
    (name.split(' ')[0] || ' ').charAt(0) +
    '' +
    (name.split(' ')[1] || ' ').charAt(0)
  );
}

function selectGroup(group) {
  emit('selectGroup', group);
  closeModal();
  searchQuery.value = '';
}
</script>

<style scoped>
.sctc-search {
  padding: 8px 16px;
}
.sctc-search-input {
  width: 100%;
  border: 0.5px solid var(--f7-list-item-border-color, var(--f7-list-item-border-color, #e0e0e0));
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  outline: none;
  background: var(--f7-list-bg-color, #f5f5f5);
}
.sctc-search-input:focus {
  border-color: var(--f7-theme-color, #1A6B42);
}
.sctc-list {
  margin-top: 0;
}
.sctc-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}
.sctc-avatar-badge {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
}
.sctc-empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--f7-on-surface-variant, #8e8e93);
  font-size: 13px;
}
</style>